import React from 'react';
import './App.css';
import './components/dashboard/dashboard.css';
import { ThemeProvider } from './context/ThemeContext';
import LoginGate from './components/LoginGate';
import PlatformShell from './platform/shell/PlatformShell';

export default function App() {
  return (
    <ThemeProvider>
      <LoginGate>
        <PlatformShell />
      </LoginGate>
    </ThemeProvider>
  );
}
